import styled from 'styled-components';

import { Color, FontWeight, Media } from '../../theme';

export const MenuIconWithLabel = styled.div`
  display: flex;
  align-items: center;
`;

export const MenuIconContainer = styled.div`
  height: 54px;
  width: 54px;
  background-color: ${Color.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 20px;
  transition: 0.2s;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  ${Media.desktop`
    margin-right: 10px;
  `}
  ${Media.tablet`
    margin-right: 0;
  `}
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0; 
    left: 0;
    opacity: 0;
    transition: all 0.3s;
    border-radius: 50%;
  }
  &:hover {
    &:after {
      background-color: ${Color.primary};
      opacity: 0.1;
    }
  }
`;

export const MenuIconLabel = styled.div`
  color: ${Color.grey};
  font-size: 12px;
  font-weight: ${FontWeight.Bold};
  letter-spacing: 1.09px;
  line-height: 15px;
  text-transform: uppercase;
  ${Media.tablet`
    display: none;
  `}
`;
